import React from "react";
import { RoleType } from "app/contexts/UserContext";
import RegistrantsAdmin from "./RegistrantsAdmin";
import RegistrantsStudent from "./RegistrantsStudent";

/**
 * Wrapper component that renders the appropriate Registrants view based on user type.
 *
 * - Coach/Facility Admin/Facility Scheduler: Full management capabilities (add/remove any student)
 * - Student: Limited view (can only remove students they added, based on canRemove flag)
 */
const Registrants = ({
  programModel,
  userType,
  onRegistrationSuccess,
  onRegistrantDeleted,
  showRegistrantsWaitlisted = false,
  onTransferComplete,
}) => {
  const isAdmin = userType === RoleType.COACH || userType === RoleType.ADMIN || userType === RoleType.SCHEDULER;

  if (isAdmin) {
    return (
      <RegistrantsAdmin
        programModel={programModel}
        onRegistrationSuccess={onRegistrationSuccess}
        onRegistrantDeleted={onRegistrantDeleted}
        showRegistrantsWaitlisted={showRegistrantsWaitlisted}
        onTransferComplete={onTransferComplete}
      />
    );
  }

  return (
    <RegistrantsStudent
      programModel={programModel}
      userType={userType}
      onRegistrantDeleted={onRegistrantDeleted}
      showRegistrantsWaitlisted={showRegistrantsWaitlisted}
    />
  );
};

export default Registrants;
